import { render, staticRenderFns } from "./HeaderlAvatar.vue?vue&type=template&id=6d9ea0e9&scoped=true"
import script from "./HeaderlAvatar.vue?vue&type=script&lang=js"
export * from "./HeaderlAvatar.vue?vue&type=script&lang=js"
import style0 from "./HeaderlAvatar.vue?vue&type=style&index=0&id=6d9ea0e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ea0e9",
  null
  
)

export default component.exports